import { reactive } from 'vue'
import actions from '@/store/exam/actions'
import state from '@/store/exam/state'
import getters from '@/store/exam/getters'

export const examModule = {
    state: reactive(state),
    actions,
    getters,
}
